(function() {
  if (window.jhangoCardInitV10) return;
  window.jhangoCardInitV10 = true;

  /* Font Awesome is loaded once from snippets/styles-scripts.liquid. */

  /* ── Per-100g calculator ──
     priceRaw = price in paise (integer from Shopify, e.g. 38000 for ₹380)
     weightVal = full option value string e.g. "500g ( Best Value - Family Size)"
  ── */
  function calcPer100g(priceRaw, weightVal) {
    const paise = parseInt(priceRaw, 10) || 0;
    if (!paise) return '';

    const w = (weightVal || '').toLowerCase();
    let grams = 0;

    if      (/1\s*kg/.test(w))  grams = 1000;
    else if (/500\s*g/.test(w)) grams = 500;
    else if (/250\s*g/.test(w)) grams = 250;
    else if (/200\s*g/.test(w)) grams = 200;
    else if (/100\s*g/.test(w)) grams = 100;
    else {
      const kgM = w.match(/(\d+\.?\d*)\s*kg/);
      const gM  = w.match(/(\d+\.?\d*)\s*g/);
      if (kgM) grams = parseFloat(kgM[1]) * 1000;
      else if (gM) grams = parseFloat(gM[1]);
    }

    if (!grams) return '';
    // paise → rupees → per-100g rupees
    const per100 = Math.round((paise / grams) * 100 / 100);
    return '₹' + per100 + ' / 100g';
  }

  document.addEventListener('DOMContentLoaded', function() {

    /* ══════════════════════════
       WEIGHT VARIANT SELECTION
    ══════════════════════════ */
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.jh-variant');
      if (!btn || btn.disabled || btn.classList.contains('active')) return;

      const card      = btn.closest('.product-card');
      const form      = card.querySelector('.jh-form');
      const varInput  = form.querySelector('.jh-variant-input');
      const atcBtn    = form.querySelector('.jh-atc');
      const priceEl   = atcBtn.querySelector('.jh-price-value');
      const unitBadge = card.querySelector('.jh-unit-badge-text');
      const atcFull   = atcBtn.querySelector('.jh-atc-full');
      const atcShort  = atcBtn.querySelector('.jh-atc-short');

      card.querySelectorAll('.jh-variant').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const jsonEl = card.querySelector('.jh-variants-json');
      const wIdx   = parseInt(card.querySelector('.jh-variants[data-weight-option-index]')?.dataset.weightOptionIndex ?? '0');
      const wVal   = btn.dataset.weightValue;

      if (jsonEl && wVal) {
        try {
          const variants = JSON.parse(jsonEl.textContent);
          const wKey = ['option1','option2','option3'][wIdx] || 'option1';
          const match = variants.find(v => v[wKey] === wVal && v.available)
                     || variants.find(v => v[wKey] === wVal);
          if (match) {
            varInput.value = match.id;
            priceEl.textContent = (match.price||'').replace('₹','').replace('Rs.','').trim();
            // Recalculate per-100g from this weight's price
            if (unitBadge) unitBadge.textContent = calcPer100g(match.price_raw, wVal);
            const ok = match.available;
            atcBtn.disabled = !ok;
            if (atcFull)  atcFull.textContent  = ok ? 'Add to Cart' : 'Sold Out';
            if (atcShort) atcShort.textContent = ok ? 'Add' : 'Sold';
            return;
          }
        } catch(ex) {}
      }
      varInput.value = btn.dataset.variantId;
      priceEl.textContent = (btn.dataset.variantPrice||'').replace('₹','').replace('Rs.','').trim();
      if (unitBadge && btn.dataset.variantUnitPrice) unitBadge.textContent = btn.dataset.variantUnitPrice;
      const ok = btn.dataset.variantAvailable === 'true';
      atcBtn.disabled = !ok;
      if (atcFull)  atcFull.textContent  = ok ? 'Add to Cart' : 'Sold Out';
      if (atcShort) atcShort.textContent = ok ? 'Add' : 'Sold';
    });

    /* ══════════════════════════
       INLINE PREF OPTION SELECT
    ══════════════════════════ */
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.jh-pref-inline-btn');
      if (!btn) return;

      const picker   = btn.closest('.jh-pref-inline');
      const form     = btn.closest('.jh-form');
      const card     = btn.closest('.product-card');
      const val      = btn.dataset.prefValue;

      picker.querySelectorAll('.jh-pref-inline-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');

      /* Resolve best variant for this weight+pref combo */
      const jsonEl = card.querySelector('.jh-variants-json');
      const prefEl = card.querySelector('.jh-pref-json');
      const wIdx   = parseInt(card.querySelector('.jh-variants[data-weight-option-index]')?.dataset.weightOptionIndex ?? '0');
      const activeW = card.querySelector('.jh-variant.active')?.dataset.weightValue || null;

      let matchPrice = '';
      let matchId    = form.querySelector('.jh-variant-input').value;

      if (jsonEl && prefEl) {
        try {
          const variants = JSON.parse(jsonEl.textContent);
          const pIdx     = JSON.parse(prefEl.textContent).index;
          const pKey     = ['option1','option2','option3'][pIdx] || 'option2';
          const wKey     = ['option1','option2','option3'][wIdx] || 'option1';
          const match = variants.find(v => v[pKey] === val && (!activeW || v[wKey] === activeW) && v.available)
                     || variants.find(v => v[pKey] === val && (!activeW || v[wKey] === activeW));
          if (match) { matchId = match.id; matchPrice = match.price || ''; }
        } catch(ex) {}
      }

      /* Update confirm button */
      const confirm = picker.querySelector('.jh-pref-confirm');
      const confText  = confirm.querySelector('.jh-pref-confirm-text');
      const confPrice = confirm.querySelector('.jh-pref-confirm-price');
      confirm.dataset.variantId = matchId;
      confText.textContent  = 'Add to Cart';
      confPrice.textContent = matchPrice ? '₹ ' + matchPrice.replace('₹','').replace('Rs.','').trim() : '';
      confirm.disabled = false;
      confirm.classList.add('ready');
    });

    /* ══════════════════════════
       BACK / CANCEL
    ══════════════════════════ */
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.jh-pref-cancel')) return;
      const form = e.target.closest('.jh-form');
      closePicker(form);
    });

    function closePicker(form) {
      form.classList.remove('pref-open');
      form.closest('.jh-atc-wrapper')?.classList.remove('pref-open');
      const picker = form.querySelector('.jh-pref-inline');
      if (picker) {
        picker.querySelectorAll('.jh-pref-inline-btn').forEach(b => b.classList.remove('selected'));
        const confirm = picker.querySelector('.jh-pref-confirm');
        confirm.disabled = true;
        confirm.classList.remove('ready','loading');
        confirm.querySelector('.jh-pref-confirm-text').textContent = 'Pick one';
        confirm.querySelector('.jh-pref-confirm-price').textContent = '';
      }
    }

    /* ══════════════════════════
       ATC SUBMIT — intercept if pref exists
    ══════════════════════════ */
    document.addEventListener('submit', function(e) {
      const form = e.target.closest('.jh-form');
      if (!form) return;
      e.preventDefault();

      /* If product has pref option and picker is NOT open yet → open picker */
      const prefEl = form.closest('.product-card')?.querySelector('.jh-pref-json');
      if (prefEl && !form.classList.contains('pref-open')) {
        form.classList.add('pref-open');
        form.closest('.jh-atc-wrapper')?.classList.add('pref-open');
        return;
      }

      /* No pref / picker already handled via confirm button */
      doATC(form, form.querySelector('.jh-variant-input').value);
    });

    /* ── Confirm button (inside picker) ── */
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.jh-pref-confirm.ready');
      if (!btn || btn.classList.contains('loading')) return;

      const form      = btn.closest('.jh-form');
      const variantId = btn.dataset.variantId || form.querySelector('.jh-variant-input').value;

      btn.classList.add('loading');
      btn.querySelector('.jh-pref-confirm-text').textContent = 'Adding…';

      closePicker(form); // snap back to ATC view
      doATC(form, variantId);
    });

    /* ══════════════════════════
       CORE ADD TO CART
    ══════════════════════════ */
    function doATC(form, variantId) {
      const btn      = form.querySelector('.jh-atc');
      const btnFull  = btn?.querySelector('.jh-atc-full');
      const btnShort = btn?.querySelector('.jh-atc-short');
      const origF    = btnFull?.textContent  || 'Add to Cart';
      const origS    = btnShort?.textContent || 'Add';

      if (btn)      btn.disabled = true;
      if (btnFull)  btnFull.textContent  = 'Adding…';
      if (btnShort) btnShort.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(r => { if (!r.ok) return r.json().then(e => { throw e; }); return r.json(); })
      .then(() => {
        if (btnFull)  btnFull.textContent  = 'Added ✓';
        if (btnShort) btnShort.textContent = '✓';
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count,[data-cart-count],.cart-icon-bubble,.cart-count-bubble')
          .forEach(el => { el.textContent = cart.item_count; });
        const t = document.querySelector('#offcanvas-cart-label span');
        if (t) t.textContent = cart.item_count;
        refreshAndOpenCart();
      })
      .catch(err => {
        console.error('Cart error:', err);
        if (btnFull)  btnFull.textContent  = 'Error';
        if (btnShort) btnShort.textContent = '!';
      })
      .finally(() => {
        setTimeout(() => {
          if (btn)      btn.disabled = false;
          if (btnFull)  btnFull.textContent  = origF;
          if (btnShort) btnShort.textContent = origS;
        }, 2500);
      });
    }

    /* ══════════════════════════
       CART DRAWER
    ══════════════════════════ */
    function refreshAndOpenCart() {
      const cart = document.getElementById('offcanvas-cart');
      if (!cart) { openCartDrawer(); return; }
      fetch('/?sections=cart-drawer,offcanvas-cart,cart-notification,mini-cart,ajax-cart')
        .then(r => r.json())
        .then(sections => {
          let done = false;
          for (const [, html] of Object.entries(sections)) {
            if (!html || typeof html !== 'string') continue;
            const doc = new DOMParser().parseFromString(html,'text/html');
            const n = doc.querySelector('cart-container,.cart-container');
            const o = document.querySelector('cart-container,.cart-container');
            if (n && o) { o.innerHTML = n.innerHTML; done = true; break; }
          }
          if (!done) return fetch('/cart',{headers:{'Accept':'text/html'}})
            .then(r=>r.text()).then(html => {
              const doc = new DOMParser().parseFromString(html,'text/html');
              for (const sel of ['cart-container','.cart-container','#cart-items','.cart-items','[data-cart-items]','.offcanvas-body']) {
                const n = doc.querySelector(sel), o = cart.querySelector(sel);
                if (n && o) { o.innerHTML = n.innerHTML; break; }
              }
            });
        })
        .catch(e => console.error(e))
        .finally(openCartDrawer);
    }

    function openCartDrawer() {
      const el = document.getElementById('offcanvas-cart');
      if (!el) return;
      if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
        bootstrap.Offcanvas.getOrCreateInstance(el).show(); return;
      }
      if (typeof $ !== 'undefined' && $.fn.offcanvas) { $(el).offcanvas('show'); return; }
      el.classList.add('show','showing');
      el.style.visibility = 'visible';
      el.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      let bd = document.querySelector('.offcanvas-backdrop');
      if (!bd) { bd = document.createElement('div'); bd.className='offcanvas-backdrop fade show'; document.body.appendChild(bd); }
      const close = () => { el.classList.remove('show','showing'); el.setAttribute('aria-hidden','true'); document.body.style.overflow=''; bd?.remove(); };
      el.querySelector('[data-bs-dismiss="offcanvas"],.btn-close')?.addEventListener('click',close);
      bd.addEventListener('click',close);
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    }

  }); /* DOMContentLoaded */
})();
